import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import SelectedSkillCard from "../../Atoms/Card/selectedSkillCard/SelectedSkillCard";
import Loading from "../../Atoms/loading/Loading";

function SelectedSkill(props) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(!false);
  const [relod, setRelod] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      setList([]);
      try {
        const snapShot = await db
          .collection("Skills")
          .where("skillCategory", "==", props.match.params.id)
          .get();
        snapShot.forEach((data) => setList((p) => [...p, data.data()]));
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    };
    fetchData();
  }, [props.match.params.id, relod]);
  // console.log(list);
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <h1 style={{ margin: "20px 0" }}>{props.match.params.id} Skills</h1>
          <div className="selectedSkills">
            {list.map((item, i) => (
              <SelectedSkillCard
                key={i}
                data={item}
                relodState={[relod, setRelod]}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default SelectedSkill;
